import { Component, OnInit, Input, OnChanges, ChangeDetectorRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { DialogService } from '../../services/dialog.service';
import { ModalHelper, _HttpClient } from '@delon/theme';
import { Icc5GCardComponent } from '../icc-5Gcard/icc-5Gcard.component';
import { deepCopy } from '@delon/util';
import { Observable, Subject } from 'rxjs';
import { map, distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { apiPrefix, telPhoneReg, webUrlReg } from '../../utils/constants';
import * as $ from 'jquery';
import { isNumber } from 'util';
import { SimpleChanges } from '@angular/core';
import { IccMediaSelectComponent } from '../icc-media-select/icc-media-select.component';
import { URLS } from '../../constant/interface';
import { PermissionControlService } from '../../services/permission-control.service';
import { IccShortChainConfigComponent } from '../icc-short-chain-config/icc-short-chain-config.component';
import { IccMapPositionComponent } from '../icc-map-position/icc-map-position.component';
import { _MSGTYPES } from '../../constant/msgType';
import { format } from 'date-fns';

type MeterialType = 'img' | 'video' | 'audio';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-5g-editor',
  templateUrl: './icc-5g-editor.component.html',
  styleUrls: ['./icc-5g-editor.component.less'],
})
export class Icc5gEditorComponent implements OnInit, OnChanges {
  constructor(private dialogService: DialogService, private modal: ModalHelper, public http: _HttpClient, private permissionControl: PermissionControlService, private cdr: ChangeDetectorRef) {}
  @ViewChild('textArea', { static: false }) textArea: any;
  downloadUrl = URLS.attachment.url;

  imgList = [];
  videoUrl = '';
  audioUrl = '';
  audioTitle = '';

  isHasShowUrl = true;

  // 新增日历起止时间范围
  addTimeRange = [];
  // 编辑日历起止时间范围
  editTimeRange = [];
  // 查看日历起止时间范围
  viewTimeRange = [];

  @Input()
  contentRoot = {
    contentType: null, // 1 多卡  2 单卡  3文本
    content: '', // 文本内容
    _5GContent: null, // 卡片列表
    suggestions: [], // 建议按钮列表
    fallBackContent: '', // 回落消息
    rcsMedia: {
      id: null,
      type: 0,
      ftpUrl: null,
      mediaUrl: null,
      mediaContentType: null,
      mediaName: null,
      mediaUntil: null,
      mediaFileSize: 0,
      thumbnailUrl: null,
      thumbnailContentType: null,
      thumbnailName: null,
      thumbnailUntil: null,
      thumbnailFileSize: 0,
      title: null,
    }, // 媒体文件
    // 插入短链相关属性
    requireShortUrl: false,
    longUrlName: null,
    longUrl: null,
    serverUrl: null,
    targetUrl: null,
    traceType: null,
    vIndex: null,
  };

  @Input()
  disabled = false;

  @Input()
  supportSuggestion = true;

  @Input()
  variableBinds = [];

  @Input()
  width = 1000;

  @Input() groupCards = 4;

  @Input() channelIds: any[];

  // 是否手动切换
  @Input() isHandChangeChannel = false;

  // 是否模版编辑
  @Input() isTplEdit = true;

  // 纯文本模式下，通知 contentRoot 的变化
  @Output() textContentChange: EventEmitter<any> = new EventEmitter<any>();

  cardList = [];

  multiCardListTmp = [];

  singleCardListTmp = [];

  vIndex = -1;

  // 新增悬浮菜单
  showAddSuggestion = false;

  // 编辑悬浮菜单
  // showEditSuggestion = false;

  mediaUrl = apiPrefix + '/common/downloadMaterial/';

  telPhoneReg = telPhoneReg;

  webUrlReg = webUrlReg;

  maxLength = 300;

  @Input() uuid: string;

  suggestionActions = [
    {
      label: '电话拨打',
      value: 1,
    },
    { label: '链接跳转', value: 2 },
    { label: '消息上行', value: 3 },
    { label: '获取终端位置', value: 4 },
    { label: '发送地理位置', value: 5 },
    { label: '共享终端信息', value: 6 },
    { label: '视频通话', value: 7 },
    { label: '创建日历', value: 8 },
  ];
  defaultSuggestion = {
    action: this.suggestionActions[0].value,
    text: null,
    param: {
      extInfo: '',
      link: {
        longUrl: '',
        longUrlName: '',
        serverUrl: '',
        traceType: 0, // 0普通链接，1小程序链接
        // 生成短链的形式参数：
        uuid: '',
        targetUrl: '',
      },
      map: {
        longitude: null,
        latitude: null,
        currentTude: '',
      },
      calendarInfo: {
        title: '',
        startTime: null,
        endTime: null,
      },
    },
  };
  suggestionTmp = deepCopy(this.defaultSuggestion);
  editSuggestionTmp = deepCopy(this.defaultSuggestion);

  _5GReplyList = [];
  search5GReplyChange$ = new Subject();

  _5GContentToCard = _5GContent => {
    let card = {
      title: _5GContent.title,
      des: _5GContent.description,
      url: this.mediaUrl + _5GContent.media.id,
      type: _5GContent.media.type === 0 ? 'img' : 'video',
      btnGroup: [],
    };
    if (_5GContent.suggestions) {
      card.btnGroup = _5GContent.suggestions.map(sug => ({ action: sug.action, name: sug.text, param: sug.param }));
    }
    return card;
  };

  ngOnInit() {
    // 设置短链功能的开启和关闭
    this.isHasShowUrl = !this.permissionControl.getLimitByField('shorturl');
    this.init5GReplySearch();
    if (this.contentRoot.contentType) {
      this.contentRoot.contentType = this.contentRoot.contentType.toString();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isHandChangeChannel) {
      this.contentRoot._5GContent = null;
      this.multiCardListTmp = [];
      this.singleCardListTmp = [];
    }
    if (isNumber(this.contentRoot.contentType)) {
      this.contentRoot.contentType = this.contentRoot.contentType.toString();
    }

    if (this.contentRoot._5GContent && this.contentRoot.contentType == 1) {
      this.multiCardListTmp = this.contentRoot._5GContent;
      this.flushCardList(this.multiCardListTmp);
    }
    if (this.contentRoot._5GContent && this.contentRoot.contentType == 2) {
      this.singleCardListTmp = this.contentRoot._5GContent;
      this.flushCardList(this.singleCardListTmp);
    }
    if (this.contentRoot.contentType == 4 && this.contentRoot.rcsMedia && this.contentRoot.rcsMedia.ftpUrl) {
      this.videoUrl = this.mediaUrl + this.contentRoot.rcsMedia.id;
    }
    if (this.contentRoot.contentType == 5 && this.contentRoot.rcsMedia && this.contentRoot.rcsMedia.ftpUrl) {
      this.imgList = [{ url: this.mediaUrl + this.contentRoot.rcsMedia.id }];
    }
    if (this.contentRoot.contentType == 6 && this.contentRoot.rcsMedia && this.contentRoot.rcsMedia.ftpUrl) {
      this.audioUrl = this.downloadUrl + this.contentRoot.rcsMedia.ftpUrl;
      this.audioTitle = this.contentRoot.rcsMedia.title ? this.contentRoot.rcsMedia.title : '';
    }
    if (this.contentRoot.suggestions && this.contentRoot.suggestions.length > 0) {
      for (let suggest of this.contentRoot.suggestions) {
        suggest.showEditSuggestion = false;
      }
    }
    if (!this.contentRoot.suggestions || this.contentRoot.suggestions.length <= 0) {
      this.supportSuggestion = false;
    } else {
      this.supportSuggestion = true;
    }
    // 适配预览日历
    if (this.disabled && this.contentRoot.suggestions) {
      this.contentRoot.suggestions.forEach(item => {
        if (item.action === 8) {
          item.param.calendarInfo = item.param.calendarInfo
            ? item.param.calendarInfo
            : {
                title: '',
                startTime: null,
                endItme: null,
              };
          item.param.calendarInfo.viewTimeRange = item.param.calendarInfo && item.param.calendarInfo.startTime && item.param.calendarInfo.endTime ? [item.param.calendarInfo.startTime, item.param.calendarInfo.endTime] : [];
        }
      });
    }
  }

  getCaretPosWithEvent(event) {
    let field = event.target;
    this.vIndex = field.selectionStart;
  }

  init5GReplySearch() {
    console.log(this.channelIds);
    const get5GReplyList = (name: string) => {
      return this.http
        .get(apiPrefix + '/common/5g/reply?q=' + name + '&&channelId=' + this.channelIds)
        .pipe(map((res: any) => res.data))
        .pipe(
          map((list: any) => {
            if (list && list.length > 0) {
              return list.map((item: any) => {
                if (item.autoMatchExtConfigs) {
                  return item.autoMatchExtConfigs[0].content;
                } else {
                  return '';
                }
              });
            }
          }),
        );
    };
    const optionList$: Observable<any> = this.search5GReplyChange$.asObservable().pipe(debounceTime(300), distinctUntilChanged(), switchMap(get5GReplyList));
    optionList$.subscribe(data => {
      this._5GReplyList = data;
    });
  }

  // contentType变动重置模板内容
  change5GContentType($event) {
    this.contentRoot.contentType = $event;
    if (this.contentRoot.contentType == 1) {
      this.flushCardList(this.multiCardListTmp);
    }
    if (this.contentRoot.contentType == 2) {
      this.flushCardList(this.singleCardListTmp);
    }
    if (this.contentRoot.contentType == 3) {
      if (!this.contentRoot.content) {
        this.contentRoot.content = '';
      }
      this.flushCardList([]);
    }
  }

  // 判断5G卡片列表是否为空
  is5GCardListEmpty(): boolean {
    return !this.contentRoot._5GContent || this.contentRoot._5GContent.length < 1;
  }

  // 添加5G卡片
  addCard() {
    if (this.contentRoot.contentType == 1 && this.contentRoot._5GContent && this.contentRoot._5GContent.length >= 10) {
      this.dialogService.notification.warning('注意', `多卡片消息最多只能录入10个卡片`);
      return;
    }
    if (this.contentRoot.contentType == 2 && this.contentRoot._5GContent && this.contentRoot._5GContent.length >= 1) {
      this.dialogService.notification.warning('注意', `单卡片消息只能录入1个卡片`);
      return;
    }
    this.modal.createStatic(Icc5GCardComponent, { variableBinds: this.variableBinds, channelIds: this.channelIds, isTplEdit: this.isTplEdit, uuid: this.uuid }, { size: 'lg' }).subscribe(card => {
      if (this.contentRoot.contentType == 1) {
        this.multiCardListTmp.push(card);
        this.flushCardList(this.multiCardListTmp);
      }
      if (this.contentRoot.contentType == 2) {
        this.singleCardListTmp = [card];
        this.flushCardList(this.singleCardListTmp);
      }
    });
  }

  flushCardList(contentList) {
    this.contentRoot._5GContent = contentList;
    if (contentList) {
      this.cardList = contentList.map(this._5GContentToCard);
    }
  }

  editCard(card) {
    const index = this.cardList.findIndex(c => c === card);
    this.modal.createStatic(Icc5GCardComponent, { card: this.contentRoot._5GContent[index], variableBinds: this.variableBinds, channelIds: this.channelIds }, { size: 'lg' }).subscribe(newCard => {
      if (this.contentRoot.contentType == 1) {
        this.multiCardListTmp[index] = newCard;
        this.flushCardList(this.multiCardListTmp);
      }
      if (this.contentRoot.contentType == 2) {
        this.singleCardListTmp = [newCard];
        this.flushCardList(this.singleCardListTmp);
      }
    });
  }

  removeCard(card) {
    const index = this.cardList.findIndex(c => c === card);
    if (this.contentRoot.contentType == 1) {
      this.multiCardListTmp.splice(index, 1);
      this.flushCardList(this.multiCardListTmp);
    }
    if (this.contentRoot.contentType == 2) {
      this.singleCardListTmp = [];
      this.flushCardList(this.singleCardListTmp);
    }
  }

  showPopoverContent() {
    // 置空新增起止时间
    this.addTimeRange = [];
    if (this.contentRoot.suggestions && this.contentRoot.suggestions.length >= 5) {
      this.dialogService.notification.warning('注意', `最多只能录入5个悬浮菜单`);
      this.showAddSuggestion = false;
      return;
    } else {
      this.showAddSuggestion = true;
    }
  }

  changeSuggestionType(value) {
    this.suggestionTmp = deepCopy(this.defaultSuggestion);
    let arr = this.suggestionActions.filter(item => {
      return item.label == value.tab.nzTitle;
    });
    this.suggestionTmp.action = arr[0].value;
  }

  editChangeSuggestionType(value) {
    this.editSuggestionTmp = deepCopy(this.defaultSuggestion);
    let arr = this.suggestionActions.filter(item => {
      return item.label == value.tab.nzTitle;
    });
    this.editSuggestionTmp.action = arr[0].value;
  }

  // 添加5G建议按钮
  saveSuggestion() {
    if (this.suggestionTmp.action === 8) {
      this.suggestionTmp.param.calendarInfo.startTime = this.addTimeRange.length > 0 ? format(this.addTimeRange[0], 'yyyy-MM-dd HH:mm:ss') : null;
      this.suggestionTmp.param.calendarInfo.endTime = this.addTimeRange.length > 1 ? format(this.addTimeRange[1], 'yyyy-MM-dd HH:mm:ss') : null;

      if (!this.suggestionTmp.param.calendarInfo || !this.suggestionTmp.param.calendarInfo.startTime || !this.suggestionTmp.param.calendarInfo.endTime) {
        this.dialogService.notification.warning('创建终端日历', '请选择起止时间！');
        return false;
      }
    }

    if (!this.contentRoot.suggestions) {
      this.contentRoot.suggestions = [];
    }
    if (this.contentRoot.suggestions.find(s => s.text === this.suggestionTmp.text)) {
      this.dialogService.notification.warning('注意', `存在同名的操作按钮名称`);
      return;
    }
    this.contentRoot.suggestions.push(this.suggestionTmp);
    this.suggestionTmp = deepCopy(this.defaultSuggestion);
    this.showAddSuggestion = false;
    console.log('this.contentRoot :>> ', this.contentRoot);
  }

  // 编辑5G建议按钮保存
  editSaveSuggestion(item) {
    if (this.editSuggestionTmp.action === 8) {
      this.editSuggestionTmp.param.calendarInfo.startTime = this.editTimeRange.length > 0 ? format(this.editTimeRange[0], 'yyyy-MM-dd HH:mm:ss') : null;
      this.editSuggestionTmp.param.calendarInfo.endTime = this.editTimeRange.length > 1 ? format(this.editTimeRange[1], 'yyyy-MM-dd HH:mm:ss') : null;

      if (!this.editSuggestionTmp.param.calendarInfo || !this.editSuggestionTmp.param.calendarInfo.startTime || !this.editSuggestionTmp.param.calendarInfo.endTime) {
        this.dialogService.notification.warning('创建终端日历', '请选择起止时间！');
        return false;
      }
    }
    // 先排除本身建议按钮
    let elseSuggestions = this.contentRoot.suggestions.filter(suggest => {
      if (item !== suggest) {
        return true;
      } else {
        return false;
      }
    });
    if (elseSuggestions.find(s => s.text === this.editSuggestionTmp.text)) {
      this.dialogService.notification.warning('注意', `存在同名的操作按钮名称`);
      return;
    }
    for (let i = 0; i < this.contentRoot.suggestions.length; i++) {
      if (this.contentRoot.suggestions[i] === item) {
        this.contentRoot.suggestions[i] = deepCopy(this.editSuggestionTmp);
        this.contentRoot.suggestions[i].showEditSuggestion = false;
      }
    }
    this.editSuggestionTmp = deepCopy(this.defaultSuggestion);
    console.log('this.contentRoot :>> ', this.contentRoot);
  }

  cancelSuggestion() {
    this.suggestionTmp = deepCopy(this.defaultSuggestion);
    this.showAddSuggestion = false;
  }

  editCancelSuggestion(item) {
    this.editSuggestionTmp = deepCopy(this.defaultSuggestion);
    item.showEditSuggestion = false;
  }

  removeSuggestion(sug) {
    this.contentRoot.suggestions.splice(
      this.contentRoot.suggestions.findIndex(s => s === sug),
      1,
    );
  }

  search5GReply(event) {
    this.search5GReplyClick(event);
  }

  search5GReplyClick(event) {
    const value = (event.target as HTMLInputElement).value;
    if (value) {
      this.search5GReplyChange$.next(value);
    } else {
      this.search5GReplyChange$.next('');
    }
  }

  insertVar(v) {
    if (this.contentRoot.content === null || this.contentRoot.content === undefined) {
      this.contentRoot.content = '';
    }
    const temp = deepCopy(this.contentRoot);
    temp.content = temp.content.slice(0, this.vIndex) + '${' + v.code + '}' + temp.content.slice(this.vIndex);
    temp.value = temp.content;
    this.contentRoot = deepCopy(temp);
    this.textContentChange.emit(this.contentRoot);
    this.vIndex = this.vIndex + v.code.length + 3;
    // 插入变量的时候，将 icc-fake-textarea 的 displayIndex，置为0，触发回显操作
    this.textArea.displayIndex = 0;
    this.cdr.detectChanges();
  }

  varMouseOver(evt) {
    $(evt.target).addClass('var-active');
  }

  varMouseLeave(evt) {
    $(evt.target).removeClass('var-active');
  }

  // 预览已存在的悬浮菜单
  // viewSuggestion($event, item) {
  //   if ($event) {
  //     if (item.action === 8) {
  //       item.param.calendarInfo = item.param.calendarInfo
  //         ? item.param.calendarInfo
  //         : {
  //             title: '',
  //             startTime: null,
  //             endItme: null,
  //           };
  //       this.viewTimeRange = item.param.calendarInfo && item.param.calendarInfo.startTime && item.param.calendarInfo.endTime ? [item.param.calendarInfo.startTime, item.param.calendarInfo.endTime] : [];
  //     }
  //   }
  // }

  // 编辑已存在的悬浮菜单
  editSuggestion(item) {
    if (!this.disabled) {
      for (let i = 0; i < this.contentRoot.suggestions.length; i++) {
        if (this.contentRoot.suggestions[i] === item) {
          this.contentRoot.suggestions[i].showEditSuggestion = true;
        } else {
          this.contentRoot.suggestions[i].showEditSuggestion = false;
        }
      }
      this.editSuggestionTmp = deepCopy(item);
      if (this.editSuggestionTmp.action === 8) {
        this.editSuggestionTmp.param.calendarInfo = this.editSuggestionTmp.param.calendarInfo
          ? this.editSuggestionTmp.param.calendarInfo
          : {
              title: '',
              startTime: null,
              endItme: null,
            };
        this.editTimeRange = this.editSuggestionTmp.param.calendarInfo && this.editSuggestionTmp.param.calendarInfo.startTime && this.editSuggestionTmp.param.calendarInfo.endTime ? [this.editSuggestionTmp.param.calendarInfo.startTime, this.editSuggestionTmp.param.calendarInfo.endTime] : [];
      }
      console.log('click.editSuggestionTmp :>> ', this.editSuggestionTmp);
    }
  }

  // 视频 & 图片 选择素材
  // 选择素材
  selectMeterial(type: MeterialType) {
    this.modal.createStatic(IccMediaSelectComponent, { mediaType: type, channelIds: this.channelIds }, { size: 1100 }).subscribe(media => {
      // console.log('this.contentRoot', this.contentRoot);
      console.log('media', media);
      this.contentRoot.rcsMedia.id = media.id;
      this.contentRoot.rcsMedia.type = media.type;
      this.contentRoot.rcsMedia.ftpUrl = media.ftpUrl;
      this.contentRoot.rcsMedia.mediaUrl = media.mediaUrl;
      this.contentRoot.rcsMedia.mediaContentType = media.mediaContentType;
      this.contentRoot.rcsMedia.mediaName = media.mediaName;
      this.contentRoot.rcsMedia.mediaUntil = media.mediaUntil;
      this.contentRoot.rcsMedia.mediaFileSize = media.mediaFileSize;
      this.contentRoot.rcsMedia.thumbnailUrl = media.thumbnailUrl;
      this.contentRoot.rcsMedia.thumbnailContentType = media.thumbnailContentType;
      this.contentRoot.rcsMedia.thumbnailName = media.thumbnailName;
      this.contentRoot.rcsMedia.thumbnailUntil = media.thumbnailUntil;
      this.contentRoot.rcsMedia.thumbnailFileSize = media.thumbnailFileSize;
      this.contentRoot.rcsMedia.title = media.title ? media.title : '';
      if (type === 'img') {
        this.imgList = [{ url: this.mediaUrl + media.id }];
      } else if (type == 'video') {
        this.videoUrl = this.mediaUrl + media.id;
      } else if (type == 'audio') {
        this.audioUrl = this.downloadUrl + media.ftpUrl;
        this.audioTitle = media.title;
      }
    });
  }

  // 重新选择
  reSelect(type: MeterialType) {
    this.selectMeterial(type);
  }

  /* 打开短链配置弹窗  */
  openShortChainModal(contentRoot) {
    if (contentRoot.content.includes('${短链接}')) {
      this.dialogService.notification.error('5G消息模板', '已存在短链,请擦除后再插入。');
      return;
    }
    this.modal.createStatic(IccShortChainConfigComponent, { contentRoot, isGeneratorLink: !this.isTplEdit, uuid: !this.isTplEdit ? this.uuid : '', msgType: _MSGTYPES.MT._5G.type }, { size: 'md' }).subscribe(result => {
      console.log(`result`, result);
      const { longUrlName, longUrl, serverUrl, traceType, targetUrl, uuid, targetUrlId } = result;
      // 无uuid，用 requireShortUrl 代替
      if (this.isTplEdit) {
        // 模版编辑
        contentRoot.requireShortUrl = true;
        contentRoot.longUrlName = longUrlName;
        contentRoot.longUrl = longUrl;
        contentRoot.serverUrl = serverUrl;
        contentRoot.traceType = traceType;
        contentRoot.targetUrlId = targetUrlId;
      } else {
        // 融合发送
        contentRoot.targetUrl = targetUrl;
      }

      this.textContentChange.emit(this.contentRoot);
    });
  }

  // 监听 fake-textarea 输入事件监听
  handelValueChange($event, template) {
    template.content = $event;

    // 监听短链是否存在 决定是否置空 targetUrl
    if (!template.content.includes('${短链接}')) {
      template.longUrlName = '';
      template.longUrl = '';
      template.serverUrl = '';
      template.traceType = '';
      template.requireShortUrl = false;
      template.targetUrlId = null;
    }
    this.textContentChange.emit(this.contentRoot);
    this.cdr.detectChanges();
  }

  setCursorOffset($event, contentRoot: any): void {
    contentRoot.vIndex = $event;
    this.vIndex = $event;
  }

  /* 新增：打开短链配置弹窗 */
  addShortChainModal() {
    this.modal.createStatic(IccShortChainConfigComponent, { isShortLink: true, isGeneratorLink: !this.isTplEdit, msgType: _MSGTYPES.MT._5G.type, uuid: this.uuid }, { size: 'md' }).subscribe(result => {
      if (result.targetUrl) {
        result.targetUrl = result.targetUrl + '${traceCode}';
      }
      console.log('addShortChainModal', result);
      this.suggestionTmp.param.link = result;
    });
  }

  /* 新增：打开选择链接弹窗 */
  addLongChainModal() {
    this.modal.createStatic(IccShortChainConfigComponent, { isShortLink: false, msgType: _MSGTYPES.MT._5G.type }, { size: 'md' }).subscribe(result => {
      console.log('addLongChainModal', result);
      this.suggestionTmp.param.link = result;
    });
  }

  /* 编辑：打开短链配置弹窗 */
  editShortChainModal() {
    this.modal.createStatic(IccShortChainConfigComponent, { isShortLink: true, isGeneratorLink: !this.isTplEdit, msgType: _MSGTYPES.MT._5G.type, uuid: this.uuid }, { size: 'md' }).subscribe(result => {
      if (result.targetUrl) {
        result.targetUrl = result.targetUrl + '${traceCode}';
      }
      console.log('editShortChainModal', result);
      this.editSuggestionTmp.param.link = result;
    });
  }

  /* 编辑：打开选择链接弹窗 */
  editLongChainModal() {
    this.modal.createStatic(IccShortChainConfigComponent, { isShortLink: false, msgType: _MSGTYPES.MT._5G.type }, { size: 'md' }).subscribe(result => {
      console.log('editLongChainModal', result);
      this.editSuggestionTmp.param.link = result;
    });
  }

  // 新增： 查询坐标
  addqueryPosition() {
    this.modal.createStatic(IccMapPositionComponent, { currentTude: '' }, { size: 'lg' }).subscribe(result => {
      console.log(`queryPosition`, result);
      this.suggestionTmp.param.map = result;
    });
  }

  // 编辑： 查询坐标
  editQueryPosition(item) {
    this.modal.createStatic(IccMapPositionComponent, { currentTude: item.param.map.currentTude }, { size: 'lg' }).subscribe(result => {
      console.log(`queryPosition`, result);
      this.editSuggestionTmp.param.map = result;
    });
  }
}
